import { api } from './api';

const getCurrentCardOrder = async ({ customerId, vouId = 1 }) => {
  const response = await api({
    url: `CardOrders/getCurrentCardOrder`,
    method: 'GET',
    params: {
      customerId,
      vouId,
    },
  });
  return response.data;
};

const getCardOrders = async ({ id }) => {
  const response = await api({
    url: `CardOrders/getbyid`,
    method: 'GET',
    params: {
      id,
    },
  });
  return response.data;
};

const cardOrdersSave = async (data) => {
  const response = await api({
    url: `CardOrders/add`,
    method: 'POST',
    data: data.entity,
  });
  return response.data;
};

const cardOrdersUpdate = async (data) => {
  const history = data?.entity?.cardActivationDate || null;
  const year = (history && new Date(history).getFullYear()) || null;
  const month = (history && new Date(history).getMonth() + 1) || null;
  data.entity.InvoiceYear = year;
  data.entity.invoiceMonth = month;
  const response = await api({
    url: `CardOrders/update`,
    method: 'PUT',
    data: data.entity,
  });
  return response.data;
};

const cardOrdersDelete = async ({ id, CancelledByUser }) => {
  const response = await api({
    url: `CardOrders/delete`,
    method: 'DELETE',
    params: {
      customerId: window.customerId,
    },
    data: {
      id,
      CancelledByUser,
      customerId: window.customerId,
    },
  });
  return response.data;
};

const deleteUnCompleted = async (vouId = 1) => {
  const response = await api({
    url: `CardOrders/deleteUnCompleted?vouId=${vouId}`,
    method: 'DELETE',
  });
  return response.data;
};

const getOrderCalculateAmountGetList = async ({
  customerId,
  vouId,
  orderTypeId,
  paymentReferenceType,
  id,
}) => {
  const response = await api({
    url: `OrderCalculateAmount/getList`,
    method: 'GET',
    params: {
      customerId,
      vouId,
      orderTypeId,
      PaymentReferenceType: paymentReferenceType,
      Id: id,
    },
  });
  return response.data;
};

const getDraftedCardOrders = async ({ customerId, pageSize, pageNumber }) => {
  const response = await api({
    url: `CardOrders/getDraftedCardOrders`,
    method: 'GET',
    params: {
      customerId,
      pageSize,
      page: pageNumber,
    },
  });
  return response.data;
};

const getCardOrderForThanksPage = async (id, customerId, provisionDay, vouId = 1) => {
  const response = await api({
    url: `CardOrders/getCardOrderForThanksPage`,
    method: 'GET',
    params: {
      id,
      customerId,
      orderProvisionDate: provisionDay,
      vouId,
    },
  });
  return response.data;
};

const getCardOrdersForStatusWithUpdaterUserName = async ({ data }) => {
  const response = await api({
    url: `CardOrders/GetCardOrdersForStatusWithUpdaterUserName`,
    method: 'GET',
    params: {
      orderStatus: data.orderStatus,
      customerId: data.customerId,
      PageSize: data.pageSize,
      Page: data.pageNumber,
      vouId: data.vouId,
    },
  });
  return response.data;
};

const cardOrderServices = {
  getCurrentCardOrder,
  getCardOrders,
  cardOrdersSave,
  cardOrdersUpdate,
  cardOrdersDelete,
  getDraftedCardOrders,
  deleteUnCompleted,
  getCardOrderForThanksPage,
  getCardOrdersForStatusWithUpdaterUserName,
  getOrderCalculateAmountGetList,
};

export default cardOrderServices;
